var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loader-container"},[_c('radar-spinner',{attrs:{"animation-duration":1500,"size":60,"color":"#ff1d5e"}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }